import { CircleAlert } from 'lucide-react';
import type { ReactElement, ReactNode } from 'react';

import styles from './StatePanel.module.css';

export interface ErrorStateProps {
    title: string;
    description?: string | undefined;
    action?: ReactNode;
}

export function ErrorState({ title, description, action }: ErrorStateProps): ReactElement {
    return (
        <div role="alert" className={[styles.panel, styles.error].join(' ')}>
            <span className={[styles.icon, styles.errorIcon].join(' ')} aria-hidden="true">
                <CircleAlert size={28} strokeWidth={1.75} />
            </span>
            <p className={styles.title}>{title}</p>
            {description !== undefined ? <p className={styles.description}>{description}</p> : null}
            {action !== undefined ? <div className={styles.action}>{action}</div> : null}
        </div>
    );
}
